import React from 'react';

import classNames from 'classnames';

import { localize } from 'wanderu-i18n';

import surprisedChiku from 'wanderu-assets/images/surprised-chiku.svg';

import localesConfig from '../../../config/explorer.locales';

import styles from './SoldOutTrip.scss';

function SoldOutTrip(props) {
    const {
        className,
        departAddr,
        arriveAddr,
        tag,
        mode,
        searchUrl,
        t,
    } = props;
    const tagKey = tag === 'both'
        ? 'fastest-and-cheapest'
        : tag;

    return (
        <div
            className={classNames(className, styles.soldOutTrip, styles.linkHover)}
            onClick={() => window.open(searchUrl, '_blank')}
        >
            <div className={styles.chikuContainer}>
                <img
                    alt={t('surprised-chiku')}
                    className={styles.surprisedChiku}
                    src={surprisedChiku}
                />
                <div className={styles.soldOut}>
                    {t('sold-out')}
                </div>
            </div>
            <div className={styles.textContainer}>
                <div className={styles.text}>
                    <div className={styles.soldOutMobile}>
                        {t('sold-out')}
                    </div>
                    <span>
                        {t('sold-out-trip-message', {
                            tag: tagKey,
                            transportationMode: mode,
                        })}
                        &nbsp;
                        {t('see-all-your-options-from', {
                            'city-to-city-link': (
                                <span
                                    className={styles.link}
                                    key="city-to-city-link"
                                >
                                    {t('city-to-city-link', {
                                        departCityName: departAddr.split(',')[0],
                                        arriveCityName: arriveAddr.split(',')[0],
                                    })}
                                </span>
                            ),
                        })}
                    </span>
                </div>
            </div>
        </div>
    );
}

export { SoldOutTrip };
export default localize(SoldOutTrip, localesConfig.namespace);
